import CreateDataContext from '../CreateDataContext'
import { initialState, loginReducers } from './login.reducers'
import { updateLoginResult } from './login.actions'

export const { Provider, Context } = CreateDataContext(
  loginReducers,
  { updateLoginResult },
  initialState,
)
